import { render, staticRenderFns } from "./AccountLogsPage.vue?vue&type=template&id=2a129e15"
import script from "./AccountLogsPage.vue?vue&type=script&lang=js"
export * from "./AccountLogsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports